import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetCurrencyBookLiquidityLimitsQueryVariables = Types.Exact<{
  currency_book_id: Types.Scalars["Int"];
}>;

export type GetCurrencyBookLiquidityLimitsQuery = {
  __typename?: "query_root";
} & {
  currency_books_by_pk?: Types.Maybe<
    { __typename?: "currency_books" } & {
      currency_book_liquidity_limits: Array<
        { __typename?: "currency_book_liquidity_limits" } & Pick<
          Types.Currency_Book_Liquidity_Limits,
          | "id"
          | "currency_book_id"
          | "notice_days_gte"
          | "notice_days_lt"
          | "upper_limit_pct"
          | "lower_limit_pct"
        >
      >;
    }
  >;
};

export const GetCurrencyBookLiquidityLimitsDocument = gql`
  query GetCurrencyBookLiquidityLimits($currency_book_id: Int!) {
    currency_books_by_pk(id: $currency_book_id) {
      currency_book_liquidity_limits {
        id
        currency_book_id
        notice_days_gte
        notice_days_lt
        upper_limit_pct
        lower_limit_pct
      }
    }
  }
`;

export function useGetCurrencyBookLiquidityLimitsQuery(
  options: Omit<
    Urql.UseQueryArgs<GetCurrencyBookLiquidityLimitsQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<GetCurrencyBookLiquidityLimitsQuery>({
    query: GetCurrencyBookLiquidityLimitsDocument,
    ...options,
  });
}
